module.exports = __webpack_public_path__ + "static/media/arrowCircleRight.de09b671.svg";